import styled from "styled-components"
import type { CSSOverflow } from "~/types/style"
import {
  Card as BaseCard,
  type CardProps as BaseCardProps,
} from "~/ur-react-components"

interface CardWrapperProps {
  borderRadius: string
  overflow?: CSSOverflow
}

const CardWrapper = styled.div<CardWrapperProps>`
  border: 1px solid ${(props) => props.theme.colors.gray95};
  border-radius: ${(props) => props.borderRadius};

  section {
    overflow: ${(props) => props.overflow ?? ""};
  }
`

export interface CardProps extends BaseCardProps {
  overflow?: CSSOverflow
}

export const Card: React.CFC<CardProps> = ({
  borderRadius = "8px",
  overflow,
  ...props
}) => {
  return (
    <CardWrapper
      className="--card-wrapper"
      borderRadius={borderRadius}
      overflow={overflow}
    >
      <BaseCard borderRadius={borderRadius} {...props} />
    </CardWrapper>
  )
}
